import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {HarService} from '../../../logging/services/har.service';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HARInterceptor implements HttpInterceptor {

    constructor(public harService: HarService) {
        this.harService = harService;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const handle = next.handle(request);
        if (request.method === 'GET' && this.harService.includeResponses) {
          handle.subscribe((data) => {
            if (data instanceof HttpResponse) {
              this.harService.addToLog(request, data);
            }
          });
        }
        return handle;
    }
}
